<template>
	<v-card class="elevation-0 forums-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div v-if="isForumList">
				<div class="forums-page__wrap">
					<div class="d-flex">
						<v-skeleton-loader
							max-width="555"
							width="100%"
							v-bind="attrs"
							type="card"
							v-if="false"
						>
						</v-skeleton-loader>
						<FeaturedPost :post="{}" v-else />
					</div>
				</div>
				<div class="date-wrapper">
					<FilterChipButtons
						:isButtonActive="isButtonActive"
						:chipsList="chipsList"
						:clearFilter="clearFilter"
						@handleChipClick="handleChipClick"
					/>
					<div v-if="filterModalIsVisible">
						<FilterModal
							:filterModalIsVisible="filterModalIsVisible"
							:currentModalFilter="currentModalFilter"
							:currentModalLabel="currentModalLabel"
							:selectedChips="selectedChips"
							:filters="filters"
							@closeModal="closeModal"
							@applySelection="applySelection"
							@setItem="setItem"
						/>
					</div>
				</div>
				<div
					class="categories-page__fake-btn-modal-containers mt-0"
					@click="openCreatePostModal"
					v-if="!this.isLoading"
				>
					<div>
						<Avatar
							class="mr-4 post-preview-card__avatar"
							:size="40"
							:avatar="profile.user_logo"
						/>
						What’s on your mind?
					</div>

					<div>
						<Icon type="pencil" :size="24" color="#9b9b9b" />
					</div>
				</div>

				<Banner v-if="banner && !isLoading" :banner="banner" :mt="12" />

				<div class="d-flex mt-3">
					<v-skeleton-loader
						v-if="isLoading"
						v-bind="attrs"
						max-width="555"
						width="100%"
						type="list-item, list-item-three-line, card-heading"
					></v-skeleton-loader>
					<div v-else style="width: 100%">
						<div v-if="forums.length === 0" class="mt-5 page-container">
							<NewsFeedEmpty title="Your forum posts is empty at the moment." />
						</div>
						<div v-for="(forum, index) in forums" :key="index">
							<ForumPreview :forum="forum" />
						</div>
					</div>
				</div>

				<div
					class="d-flex my-9 justify-center home-page__pagination"
					v-if="!isLoading && forums.length > 0"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.pageForums"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
			<div v-else>
				<CommunityView
					:communityView="communityView"
					:bookmarked="bookmarked"
					:userCounter="userCounter"
					@addToBookmark="addToBookmark"
				/>
			</div>

			<CreatePostModal
				ref="createPostModal"
				v-on:closeModal="closeCreatePostModal"
				:show="isShowCreatePostModal"
				:categoryId="categoryId"
			/>

			<v-btn
				v-show="isShowCreatePostButton"
				@click="openCreatePostModal"
				bottom
				right
				class="add-post-button"
				fixed
				fab
			>
				<Icon type="plus" color="#ffffff" :size="24" />
			</v-btn>

			<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
		<v-dialog v-model="isCreate" max-width="588px" width="100%" persistent>
			<v-card class="exhibitor-page__modal">
				<div class="exhibitor-page__modal__title">
					Please join the community to start discussions.
				</div>
				<button type="button" @click="isCreate = false" class="exhibitor-page__modal__btn">
					OK
				</button>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import ForumPreview from '@/components/Forum/ForumPreview'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Avatar from '@/components/Avatar'
import Banner from '@/components/Banner'
import Filter from '@/mixins/Filter'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import CommunityView from '@/components/Forum/CommunityView.vue'
import { EventBus } from '@/services/event-bus'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'EventsPage',
	mixins: [Block, Filter, Dwh],
	components: {
		FilterModal,
		FilterChipButtons,
		CreatePostModal,
		FeaturedPost,
		NewsFeedEmpty,
		ForumPreview,
		Pagination,
		PageBlocked,
		Avatar,
		Banner,
		CommunityView,
	},

	methods: {
		...mapActions('forum', [
			'fetchForums',
			'getModalCategories',
			'resetModalCategories',
			'getCommunity',
		]),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),
		...mapActions('app', ['setPageTitle']),
		...mapActions('event', ['toggleBookmark']),
		async addToBookmark() {
			const newStatus = this.bookmarked ? 0 : 1
			this.userCounter += newStatus ? 1 : -1
			await this.toggleBookmark({
				user_id: this.currentUser.user_id,
				bookmark_entity_type: this.communityView.bookmark.bookmark_entity_type,
				bookmark_status: newStatus,
				bookmark_entity_id: this.communityView.bookmark.bookmark_entity_id,
			})
			this.bookmarked = newStatus
		},
		toggleForumList(val) {
			this.isForumList = val
			let typeAction = val ? 'click_discussions_tab' : 'click_about_tab'
			this.sendTrigger({
				category: 'Community View',
				action: typeAction,
				module: 'Forums / Communities',
				title: this.$route.query.name,
				id1: this.$route.params.id,
			})
		},
		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264
		},
		async openCreatePostModal() {
			if (!this.bookmarked) {
				this.isCreate = true
				return
			}
			this.resetModalCategories()
			await this.getModalCategories({
				query: '?category_type=1&filter=bookmark&fields=thread_category_id,category_name',
				page: 1,
			})

			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isShowCreatePostModal = false
		},
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.fetchForums(this.requestQuery)
			this.sendTrigger({
				category: 'Community View',
				action: 'view_category',
				module: 'Forums / Communities',
				title: this.$route.query.name,
				id1: this.$route.params.id,
			})
			this.getCommunity(this.$route.params.id)
			this.getBanner({
				places: ['forum_posts'],
				place_sub_id: this.$route.params.id,
				page: this.filters.page,
			})
		}
		EventBus.$on('toggleForumList', this.toggleForumList)
	},

	computed: {
		...mapGetters('forum', [
			'forums',
			'isLoading',
			'pageForums',
			'modalCategories',
			'communityView',
			'communityViewLoading',
			'communityViewError',
		]),
		...mapGetters('advertisement', ['banner']),
		...mapGetters('auth', ['profile']),
		currentUser() {
			return this.profile
		},

		categoryId() {
			if (this.$route.params.id !== undefined) {
				return Number(this.$route.params.id)
			}
			return null
		},
	},
	watch: {
		communityView: {
			immediate: true,
			handler(val) {
				this.bookmarked = val?.bookmark?.is_bookmarked || 0
				this.userCounter = val?.forum_users_count || 0
			},
		},
	},

	mounted() {
		this.setPageTitle('Community')
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},
	beforeDestroy() {
		this.setPageTitle('')
		window.removeEventListener('scroll', this.toggleVisibility)
		window.removeEventListener('resize', this.checkScreenWidth)
		EventBus.$off('toggleForumList', this.toggleForumList)
		this.clearBanner()
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isCreate: false,
			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false,

			page: '',
			pageBlockedName: 'forums',
			isForumList: true,
			bookmarked: null,
			userCounter: 0,
		}
	},
}
</script>

<style lang="scss">
.forums-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat;
		font-weight: bold;
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
		}

		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}
	}
}

.post {
	&__search {
		background: white;
		height: 54px;
		border-radius: 10px;
		border: 1px solid rgb(230, 230, 230);
		max-width: 600px;
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}
}

.page-container {
	max-width: 600px;
}
</style>
